export default __webpack_public_path__ + "static/stories-banner-920c78a5ad62dd466094739835e34b59.jpg";